export class AirportMaintenanceTableData {
  seqNo: number;
  airportCode: string | null;
  airportName: string | null;
  locatedCitySeqNo: number | null;
  isActivated: number | null;
  createUser: string | null;
  createDt: Date | null;
  updateUser: string | null;
  updateDt: Date | null;
  dataKey: string;

  constructor() {
    this.seqNo = -1;
    this.airportCode = null;
    this.airportName = null;
    this.locatedCitySeqNo = null;
    this.isActivated = null;
    this.createUser = null;
    this.createDt = null;
    this.updateUser = null;
    this.updateDt = null;
    this.dataKey = "";
  }
}
